
<div class="parent">
    <div id="background"></div>
    <div class="login-page" [ngStyle]="loginBGImage">
        <div class="content">
            <div class="top-title">
                <img src="{{loginImage}}" class="circle z-depth-2 responsive-img activator" alt="{{subTitle}}"
                    style="width: 200px; margin-bottom: 5vh;" (error)="loginImage = loginDefaultImage">
            </div>
            <form class="login-form" fxFlex>
                <h1 class="header-center">Login</h1>
                <div fxFlex fxlayout="row" fxlayout.lt-md="column" [hidden]="!(forgotPass || !passwordNeeded)">
                    <div fxFlexFill>
                        <mat-form-field class="w-100">
                            <input #emailInput="matInput" matInput placeholder="{{ 'Email' | translate }}"
                                [value]="email" (change)="email=$event.target.value"
                                (keydown.enter)="handleEmailEnter($event)">
                        </mat-form-field>
                    </div>
                </div>
                <div fxFlex fxLayout="row" fxLayout.lt-md="column" *ngIf="!forgotPass && passwordNeeded">
                    <div fxFlexFill>
                        <mat-form-field class="w-100">
                            <input #passwordInput="matInput" matInput type="password" class="type-toggle"
                                placeholder="{{ 'Password' | translate }}" [value]="password"
                                (change)="password=$event.target.value" (keydown.enter)="onLoginWithPassword($event)">
                            <mat-icon class="primaryColor show-option" (click)="toggleShow()" [hidden]="showPassword">
                                visibility_off</mat-icon>
                            <mat-icon class="primaryColor hide-option" (click)="toggleShow()" [hidden]="!showPassword">
                                visibility</mat-icon>
                        </mat-form-field>
                    </div>
                </div>
                <div fxFlex fxLayout="row" fxLayout.lt-md="column" style="margin-top: 40px; margin-bottom: 25px;">
                    <div fxFlexFill class="content-center">
                        <button *ngIf="!forgotPass && !passwordNeeded" type="button" [disabled]="loading"
                            mat-raised-button color="primary" class="w-100 btn-primary"
                            (click)="onLogin(undefined)">{{'Proceed' |
                            translate}}</button>
                        <button *ngIf="!forgotPass && passwordNeeded" type="button" [disabled]="loading"
                            mat-raised-button color="primary" class="w-100 btn-primary"
                            (click)="onLoginWithPassword(undefined)">{{'Sign-in' |
                            translate}}</button>
                        <button *ngIf="forgotPass" type="button" [disabled]="loading" mat-raised-button color="primary"
                            class="w-100 loginBtn btn-primary" (click)="onForgotPass()">{{ 'Submit' | translate
                            }}</button>
                    </div>
                </div>
                <div fxFlex fxLayout="row" fxLayout.lt-md="column" class="fpass">
                    <div fxFlex *ngIf="!forgotPass && passwordNeeded">
                        <a href="javascript:void(0)" (click)="setEmailFocus()">{{ 'Back to Email' | translate }}</a>
                    </div>
                    <div fxFlex *ngIf="forgotPass && passwordNeeded">
                        <a href="javascript:void(0)" (click)="setForgotPassFocus(false)">{{ 'Back to Login' | translate
                            }}</a>
                    </div>
                    <div fxFlex style="text-align:left" *ngIf="!passwordNeeded">
                        <a href="https://www.interactivelife.com/privacy" target="_blank">{{ 'Privacy' | translate
                            }}</a>
                    </div>
                </div>
                <div fxFlex fxLayout="row" fxLayout.lt-md="column" class="fpass"
                    *ngIf="orgId === '5fc50248015914704358cf79' && !passwordNeeded">
                    <div fxFlex>
                        <div
                            style="font-style: italic;max-width:18vw;text-align:justify;font-size: 0.8rem;color:#565656">
                            If you have issues logging in please email <a href="mailto:support@interactivelife.com"
                                target="_blank">support&#64;interactivelife.com</a> or contact +1484.808.5876
                        </div>
                    </div>
                </div>
                <div fxFlex fxLayout="row" fxLayout.lt-md="column" class="fpass" *ngIf="!forgotPass && passwordNeeded">
                    <div fxFlex>
                        <a href="javascript:void(0)" (click)="setForgotPassFocus(true)">{{ 'Forgot / Reset Password' |
                            translate }}</a>
                    </div>
                </div>
                <button *ngIf="enableTranslation" class="languageSelection" mat-icon-button
                    [matMenuTriggerFor]="languageselect" (click)="cancelThru($event)">
                    <mat-icon class="primaryColor">language</mat-icon>
                </button>
                <mat-menu #languageselect="matMenu">
                    <button mat-menu-item (click)="setLanguage('en')" [disabled]="language === 'en'"><span
                            class="primaryColor">
                            {{'English' | translate}}</span></button>
                    <button mat-menu-item (click)="setLanguage('fr')" [disabled]="language === 'fr'"><span
                            class="primaryColor">{{'French' | translate}}</span></button>
                </mat-menu>
            </form>

            <p class="account">Don't have an account? &nbsp;&nbsp;<a [routerLink]="['/register']">Sign up</a> </p>
        </div>
    </div>
</div>